import * as um from 'generated/api/um.api';

type GetUserProfile = um.paths['/api/profile'];
export type UserProfile = GetUserProfile['get']['responses']['200']['schema'];

type GetAchievements = um.paths['/api/achievements/list'];
export type Achievements = GetAchievements['get']['responses']['200']['schema'];
